export default __webpack_public_path__ + "static/media/nft-calender.c5ef49e5.png";